import { defineMessages } from '@atlassian/jira-intl';

export const validationMessages = defineMessages({
	errorMessageIssueTypeDescriptionTooLong: {
		id: 'project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-description-too-long',
		defaultMessage:
			'Description should be {maximumDescriptionLength, plural, one {# character} other {# characters}} or less',
		description:
			'Error message shown when the user has entered text that exceeds the maximum allowed length for the "request type description" field in a form',
	},
	errorMessageInvalidDefaultValue: {
		id: 'project-settings-product-features-jsm-cmp.utils.validation.error-message-invalid-default-value',
		defaultMessage: 'Enter a valid preset value.',
		description: 'The error shown on a field’s configuration when its preset value is invalid.',
	},
	errorMessageIssueTypeHelpTextTooLong: {
		id: 'project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-help-text-too-long',
		defaultMessage:
			'Help text can’t exceed {maximumHelpTextLength, plural, one {# character} other {# characters}}',
		description: 'Error message shown when the request type help text is too long.',
	},
	errorMessageIssueTypeNameTooLong: {
		id: 'project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-name-too-long',
		defaultMessage:
			'Request type name can’t exceed {maximumNameLength, plural, one {# character} other {# characters}}',
		description: 'Error message shown when the request type name is too long.',
	},
	errorMessageEmptyIssueTypeName: {
		// also used in `src/packages/servicedesk/ticket-type-fields/src/ui/layout/header/inline-edit/messages.js`

		id: 'ticket-type-fields.layout.header.inline-edit.warning',
		defaultMessage: 'You must specify a ticket type name',
		description: 'Warning message shown when user attempts to leave ticket type name field empty',
	},
});

export const descriptionInlineInputMessages = defineMessages({
	label: {
		id: 'jsd.project-settings-apps.add-issue-type.main-modal.content.description-input.label',
		defaultMessage: 'Portal description',
		description: 'Request type description text input label when creating new Request Type',
	},
	editDescriptionButtonLabel: {
		id: 'jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.edit-description-button-label',
		defaultMessage: 'Edit description',
		description: 'Label used by screen readers when focusing on the description input',
	},
	descriptionPlaceholder: {
		id: 'jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.placeholder',
		defaultMessage: 'Let people know when to use this request type',
		description: 'Description inline input placeholder',
	},
});

export const helpTextInlineInputMessages = defineMessages({
	label: {
		id: 'project-settings-apps.issue-type-page.main-content-jsm.help-text-label',
		defaultMessage: 'Portal instructions',
		description: '',
	},
	editDescriptionButtonLabel: {
		id: 'project-settings-apps.issue-type-page.main-header.help-text-inline-input.edit-button-label',
		defaultMessage: 'Edit portal instructions',
		description: 'Label used by screen readers when focusing on the help text input',
	},
	descriptionPlaceholder: {
		id: 'project-settings-apps.issue-type-page.main-content-jsm.help-text-placeholder',
		defaultMessage: 'Enter text to help your customers complete this form correctly.',
		description: '',
	},
});
